import { dataLayerPush } from "./data-layer-push";

export function trackingOnLanguageChange(languageKey: string) {
  dataLayerPush({
    jobboardLang: languageKey,
  });
}
